import { render, staticRenderFns } from "./farming.vue?vue&type=template&id=05c8436a&"
var script = {}
import style0 from "./farming.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports